import { render, staticRenderFns } from "./UserChangePasswordForm.vue?vue&type=template&id=c6d428e6"
import script from "./UserChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./UserChangePasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports